"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appThemeLight = exports.appThemeDark = void 0;
var tslib_1 = require("tslib");
var app_theme_dark_1 = tslib_1.__importDefault(require("./app-theme-dark"));
exports.appThemeDark = app_theme_dark_1.default;
var app_theme_light_1 = tslib_1.__importDefault(require("./app-theme-light"));
exports.appThemeLight = app_theme_light_1.default;
var getAppTheme = function (themeType) {
    if (themeType === 'dark') {
        return app_theme_dark_1.default;
    }
    return app_theme_light_1.default;
};
exports.default = getAppTheme;
//# sourceMappingURL=index.js.map